import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from '../shared/ui';
import { AppShell } from '../widgets/app-shell';
import { loadChartsPage } from './preload';

const LazyChartsPage = lazy(() => loadChartsPage().then((m) => ({ default: m.ChartsPage })));

export function ChartsPage() {
  return (
    <Suspense fallback={<ChartsPageLoading />}>
      <LazyChartsPage />
    </Suspense>
  );
}

/** While the page's code loads, the shell stays put and the page shows its usual spinner. */
function ChartsPageLoading() {
  const { t } = useTranslation();
  return (
    <AppShell page="charts" crumbs={[t('nav.charts')]}>
      <div className="w-full space-y-4 px-6 py-6 max-sm:px-4">
        <h1 className="text-lg font-semibold">{t('nav.charts')}</h1>
        <div className="flex justify-center py-16">
          <Spinner label={t('common.loading')} />
        </div>
      </div>
    </AppShell>
  );
}
